/*@ngInject*/
const RowEditorController = function ($rootScope, $scope, $element, formViewerConstant, formMediator, formTemplateStatus, modalUtil, localization, authorizationConstants, currentUserModel) {

    this.translations = {};
    this.canDeleteRow = false;
    this.isDeleteVisible = false;

    this.$onInit = function () {
        let userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS),
            isUnsavedField;

        localization.getTranslations().then(function (translations) {
            this.translations = translations;
        }.bind(this));

        isUnsavedField = !_.isNil(this.rowStructure.rowTemplate) && !_.isNil(this.rowStructure.rowTemplate.repeaterField) && this.rowStructure.parentUiFormTemplate.formTemplate.id !== this.rowStructure.rowTemplate.repeaterField.fieldTemplate.formTemplateId;
        this.canDeleteRow = isUnsavedField || userCanManageForms && this.rowStructure.parentUiFormTemplate.formTemplate.status !== formTemplateStatus.IN_PRODUCTION;
    };

    this.onDeleteRowStructure = function () {
        let message = _.get(this.translations, 'rowEditor.deleteRowConfirmation.summary'),
            title = _.get(this.translations, 'rowEditor.deleteRowConfirmation.title'),
            cancelButtonLabel = _.get(this.translations, 'genericButtons.cancel'),
            confirmButtonLabel = _.get(this.translations, 'genericButtons.continue');

        function handleClose() {
            formMediator.deleteRow(this.rootFormId, this.rowStructure.rowStructureId);
        }

        modalUtil.showGenericConfirm({
            cancelButtonLabel: cancelButtonLabel,
            confirmActionButtonLabel: confirmButtonLabel,
            summary: message,
            title: title
        }).then(handleClose.bind(this));
    };

    this.updateDeleteVisibility = function () {
        this.isDeleteVisible = this.canDeleteRow && this.rowStructure.selected;
    };

    $scope.$on(formViewerConstant.configuration.event.SECTION_SELECTION_CHANGE, function () {
        this.rowStructure.selected = false;
        this.updateDeleteVisibility();
    }.bind(this));

    $scope.$on(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, function (event, rowStructure) {
        this.rowStructure.selected = rowStructure.rowStructureId === this.rowStructure.rowStructureId;
        this.updateDeleteVisibility();
    }.bind(this));

    $scope.$on(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, function () {
        this.rowStructure.selected = false;
        this.updateDeleteVisibility();
    }.bind(this));

    $scope.$on(formViewerConstant.configuration.event.DELETE_FIELD, function () {
        if(!_.isNil(this.rowStructure.rowList) && !_.isNil(this.rowStructure.viewContainer) && this.rowStructure.rowList[0].fieldStructureList.length === 1){
            formMediator.deleteRow(this.rootFormId, this.rowStructure.rowStructureId);
        }
    }.bind(this));
};

angular.module('umFormViewer')
    .controller('rowEditorController', RowEditorController);
